import React from 'react';
import './testimonial.css';
import 'swiper/css';
import 'swiper/css/pagination';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { Data } from './Data';

const Testimonials = () => {
  return (
    <section id='testimonials' className="testimonoals section container">
      <h2 className="section__title">Отзывы</h2>
      <span className="section__subtitle">Моих клиентов</span>
      <Swiper
        loop={true}
        grabCursor={true}
        spaceBetween={24}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 48,
          },
        }}
        modules={[Pagination]}
        className="testimonial__container">
        {Data.map(({ id, image, title, description }) => (
          <SwiperSlide key={id} className="testimonial__card">
            <img src={image} alt={title} className="testimonial__img" />
            <h3 className="testimonial__name">{title}</h3>
            <p className="testimonial__description">{description}</p>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;
